import styled from "styled-components";

export const StyledPhotoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
    width: 100%;
`;

export const StyledThumbContainer = styled.div`
    position: relative;
    aspect-ratio: 1 / 1;

    border-radius: 8px;
    overflow: hidden;

    border: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .actions {
        position: absolute;
        top: 4px;
        right: 4px;

        display: flex;
        align-items: center;
        gap: 4px;
    }

    .anticon {
        color: ${({ theme }) => theme.colors.white};
        font-size: 13px;

        cursor: pointer;

        padding: 5px;
        border-radius: 5px;

        background: rgba(0, 0, 0, 0.55);
        backdrop-filter: blur(2px);

        transition: background 0.2s;

        &:active {
            background: rgba(0, 0, 0, 0.8);
        }
    }
`;

export const StyledAddButton = styled.button`
    aspect-ratio: 1 / 1;

    border: 1px dashed ${({ theme }) => theme.secondaryBorderColor};
    border-radius: 8px;

    background: ${({ theme }) => theme.secondaryBackgroundColor};

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 6px;

    cursor: pointer;

    font-size: 12px;
    color: ${({ theme }) => theme.secondaryTypographyColor};

    transition:
        border-color 0.2s,
        color 0.2s;

    flex-shrink: 0;

    &:active {
        border-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.primary};
    }

    .anticon {
        font-size: 20px;
    }
`;
